import singleServiceTime from '@xt/client/experimental/server-time'
import moment from 'moment'

export const getAsDays = (sourceTime: null | number) => {
  if (!sourceTime) return 0

  const now = singleServiceTime.getServerTime('moment')

  return Math.floor(moment.duration(now.diff(sourceTime)).asDays())
}
